'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Auth = require('components/Auth');

var _Icons = require('components/Common/Icons');

var _Common = require('components/Common');

var _User = require('components/User');

var _routing = require('constants/routing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./UserMenuFull.pcss');

var UserMenuFull = (_temp = _class = function (_Component) {
  _inherits(UserMenuFull, _Component);

  function UserMenuFull() {
    _classCallCheck(this, UserMenuFull);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserMenuFull).apply(this, arguments));
  }

  _createClass(UserMenuFull, [{
    key: 'getContent',
    value: function getContent() {
      var _props = this.props;
      var authorizedUser = _props.authorizedUser;
      var foreignUser = _props.foreignUser;
      var open = _props.open;


      if (!open || !authorizedUser) return null;

      return _react2.default.createElement(
        'div',
        { className: styles.userMenuFull },
        _react2.default.createElement(
          _Common.Menu,
          { close: this.props.onClose },
          _react2.default.createElement(
            _Common.Menu.Item,
            { onClick: this.props.onClose },
            foreignUser ? _react2.default.createElement(
              _Common.Link,
              { jalan: { type: _routing.JALAN_INDEX }, noUnderline: true },
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(styles.user, this.props.withMyPageLink && styles.myPageLink) },
                _react2.default.createElement(_User.UserPic, { my: true, url: authorizedUser.avatarUrl }),
                _react2.default.createElement(
                  'div',
                  { className: styles.name },
                  authorizedUser.displayName
                )
              )
            ) : _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(styles.user, this.props.withMyPageLink && styles.myPageLink) },
              _react2.default.createElement(_User.UserPic, { my: true, url: authorizedUser.avatarUrl }),
              _react2.default.createElement(
                'div',
                { className: styles.name },
                authorizedUser.displayName
              )
            )
          ),
          _react2.default.createElement(
            _Auth.Logout,
            null,
            _react2.default.createElement(
              _Common.Menu.Item,
              null,
              _react2.default.createElement(
                _Common.Menu.ItemIcon,
                null,
                _react2.default.createElement(_Icons.Exit, { width: '18', height: '18' })
              ),
              _react2.default.createElement(
                _Common.Menu.ItemLabel,
                null,
                'Log out'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          component: 'div',
          transitionName: {
            enter: styles.enter,
            enterActive: styles.enterActive,
            leave: styles.leave,
            leaveActive: styles.leaveActive
          },
          transitionEnterTimeout: 240,
          transitionLeaveTimeout: 180
        },
        this.getContent()
      );
    }
  }]);

  return UserMenuFull;
}(_react.Component), _class.propTypes = {
  authorizedUser: _react.PropTypes.object,
  foreignUser: _react.PropTypes.string,

  onClose: _react.PropTypes.func.isRequired,
  open: _react.PropTypes.bool
}, _temp);
exports.default = UserMenuFull;


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserMenu/UserMenuFull.js
// module id = 617
// module chunks = 1